module.exports = __webpack_public_path__ + "media/images/ticket/automatic_input-758fef2c37ce63b59da0f2b112797a8c.png";